export const COMPETITION_ID = "-OIKa_crfHFq60Ydq2Lj";
